import { useMemo } from "react";
import { useTenant } from "./useTenant";

/**
 * usePermissions
 * Hook extrito e sem "jeitinhos" para controle de acesso via Custom Claims.
 * 
 * Regra:
 * A autorização NÃO consulta o banco de dados.
 * Ou a permissão está injetada no Token de Autenticação, ou o acesso é negado.
 */
export const usePermissions = () => {
    const { claims, loading } = useTenant();

    const role = claims?.role || null;

    const permissions = useMemo(() => {
        return claims?.permissions || {};
    }, [claims]);

    /**
     * Verifica permissão individual
     */
    const can = (permissionPath) => {
        if (!role) return false;
        if (role === "super_admin" || role === "owner") return true;

        return permissions[permissionPath] === true;
    };

    /**
     * Verifica array de permissões (se ele tem QUALQUER UMA delas)
     */
    const canAny = (permsArray = []) => {
        if (!role) return false;
        if (role === "super_admin" || role === "owner") return true;

        return permsArray.some(p => permissions[p] === true);
    };

    /**
     * Validação direta de Cargo absoluto 
     */
    const is = (targetRole) => {
        return role === targetRole;
    };

    return {
        can,
        canAny,
        is,
        isSuperAdmin: role === "super_admin",
        isOwner: role === "owner",
        isEmployee: role === "employee",
        permissions,
        role,
        loading
    };
};
